<template>
  <a-modal
    :title="obj ? '编辑设备' : '新增设备'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="editForm"
      :model="editForm"
      :rules="editFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="设备SN" prop="sn">
        <a-input v-model="editForm.sn" placeholder="请填写设备SN" />
      </a-form-model-item>

      <a-form-model-item label="设备类型" prop="deviceType">
        <a-select v-model="editForm.deviceType" :disabled="!!obj" >
          <a-select-option v-for="(item,index) in DeviceTypes" :key="index" :value="item.code">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="state">
        <a-radio-group v-model="editForm.state" :default-value="0">
          <a-radio :value="0">正常</a-radio>
          <a-radio :value="1">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import store from "@/store";

const enumsData = store.state.enumsStore.enumsData
const { DeviceType: DeviceTypes } = enumsData

const editForm = {
  id: undefined,
  sn: undefined,
  state: 0,
  deviceType: undefined,
}
const editFormRules = {
  sn: [{ required: true, message: '请填写SN！' }],
  deviceType: [{ required: true, message: '请选择类型！' }],
}


export default {
  name: 'EditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      editForm,
      editFormRules,
      DeviceTypes,
      templateList:[],
      uploading: false,
      confirmLoading:false
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          const { id, sn, state, deviceType } = this.obj
          this.editForm = { id, sn, state, deviceType }
        })
      }
    }
  },
  created() {},
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.editForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.editForm.resetFields()
      this.editForm = editForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
